export default __webpack_public_path__ + "30fab328ec04ab1a2791059ee58754b8.svg";